import { apiSlice } from "../../../app/apiSlice";
import configUrls from "../../../config/configUrls";
import { DocumentoAssinar } from "../../../types/documento/assinar/DocumentoAssinar";
import { DocumentoAssinarDTO } from "../../../types/documento/assinar/DocumentoAssinarDTO";
import { DocumentoAssinarList } from "../../../types/documento/assinar/DocumentoAssinarList";

const endpointUrl = configUrls.DOCUMENTO_ASSINAR_EP;

/**versoes */

function getDocumentoAssinaturas({
  id,
  search,
}: {
  id: string;
  search: string;
}) {
  if (!id) {
    // Se 'documento' for null/undefined ou não tiver 'id', não faz a chamada à API.
    return {
      url: "",
      method: "",
    };
  }

  return {
    url: `${endpointUrl}/assinaturas/${id}?search=${search}`,
    method: "GET",
  };
}

function getDocumentoAssinar(id: string) {
  if (!id) {
    // Se 'documento' for null/undefined ou não tiver 'id', não faz a chamada à API.
    return {
      url: "",
      method: "",
    };
  }

  return {
    url: `${endpointUrl}/assinar/${id}`,
    method: "GET",
  };
}

function login({ idDocumento, login, senha }: DocumentoAssinarDTO) {
  return {
    url: `${endpointUrl}/assinar`,
    method: "POST",
    body: {
      login: login,
      senha: senha,
      idDocumento: idDocumento,
    },
  };
}

/** */

export const documentoAssinarApiSlice = apiSlice.injectEndpoints({
  endpoints: ({ query, mutation }) => ({
    DocumentoAssinarLogin: mutation<void, DocumentoAssinarDTO>({
      query: login,
      invalidatesTags: ["Login"],
    }),

    getDocumentoAssinaturas: query<
      DocumentoAssinarList[],
      { id: string; search: string }
    >({
      query: getDocumentoAssinaturas,
      providesTags: ["DocumentoAssinar"],
    }),

    getDocumentoAssinar: query<DocumentoAssinar, string>({
      query: getDocumentoAssinar,
      providesTags: ["DocumentoAssinar"],
    }),
  }),
});

export const {
  useGetDocumentoAssinarQuery,
  useGetDocumentoAssinaturasQuery,
  useDocumentoAssinarLoginMutation,
} = documentoAssinarApiSlice;
